import Vue from 'vue';
import Vuex from 'vuex';
import { defaultLanguage } from '@/scripts/language';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    games: null,
    allGamesTypes: {},
    /*  */
    user: null,
    userData: null,
    tiers: null,
    balances: null,
    /*  */
    showModalBonus: false,
    showModalSlider: false,
    showModalMenu: false,
    showModalConfirm: false,
    showModalCheckEmail: false,
    showModalEnterCode: false,
    showModalLeaderboardData: false,
    /*  */
    error: null,
    errorCloseCallback: null,
    /*  */
    language: defaultLanguage,
    /*  */
    activeGame: null,
    activeGameType: null,
    activeGamePlatform: null,
    activeTimeFilter: null,
  },
  mutations: {
    /*  */
    setGames(state, games) {
      state.games = games;
    },
    setGameTypes(state, payload) {
      const { id, types } = payload;
      const merged = { ...state.allGamesTypes, [id]: types };

      state.allGamesTypes = merged;
    },
    /*  */
    setError(state, error) {
      state.error = error;
    },
    setErrorCloseCallback(state, callback) {
      state.errorCloseCallback = callback;
    },
    setLanguage(state, language) {
      state.language = language;
    },
    setUser(state, user) {
      state.user = user;
    },
    setUserData(state, data) {
      state.userData = data;
    },
    setTiers(state, data) {
      state.tiers = data;
    },
    setBalances(state, data) {
      state.balances = data;
    },
    setShowModalBonus(state, payload) {
      state.showModalBonus = payload;
    },
    setShowModalSlider(state, payload) {
      state.showModalSlider = payload;
    },
    setShowModalMenu(state, payload) {
      state.showModalMenu = payload;
    },
    setShowModalConfirm(state, payload) {
      state.showModalConfirm = payload;
    },
    setShowModalCheckEmail(state, payload) {
      state.showModalCheckEmail = payload;
    },
    setShowModalEnterCode(state, payload) {
      state.showModalEnterCode = payload;
    },
    setShowModalLeaderboardData(state, payload) {
      state.showModalLeaderboardData = payload;
    },
    setActiveGame(state, payload) {
      state.activeGame = payload;
    },
    setActiveGameType(state, payload) {
      state.activeGameType = payload;
    },
    setActiveGamePlatform(state, payload) {
      state.activeGamePlatform = payload;
    },
    setActiveTimeFilter(state, payload) {
      state.activeTimeFilter = payload;
    },
  },
  actions: {
    /* ... . .-. --. . / --.. .... ..- .-. .- ...- .-.. . ...- */
    setLanguage(context, language) {
      context.commit('setLanguage', language);
    },
    setUser(context, user) {
      context.commit('setUser', user);
    },
    setUserData(context, data) {
      context.commit('setUserData', data);
    },
    setTiers(context, data) {
      context.commit('setTiers', data);
    },
    setBalances(context, data) {
      context.commit('setBalances', data);
    },
    setError(context, e) {
      context.commit('setError', e);
    },
    setErrorCloseCallback(context, f) {
      context.commit('setErrorCloseCallback', f);
    },
    setGames(context, games) {
      context.commit('setGames', games);

      /* activeGame */
      const storedActiveGame = localStorage.getItem('activeGame');
      const storedGameChecked = games.some(({ id }) => id === storedActiveGame);
      const [firstGame = {}] = games;
      const { id: firstGameId } = firstGame;
      const activeGame = storedGameChecked ? storedActiveGame : firstGameId;

      context.commit('setActiveGame', activeGame);
    },
    toggleModalBonus(context, state = false) {
      context.commit('setShowModalBonus', state);
    },
    toggleModalMenu(context, state = false) {
      context.commit('setShowModalMenu', state);
    },
    toggleModalConfirm(context, state = false) {
      context.commit('setShowModalConfirm', state);
    },
    toggleModalCheckEmail(context, state = false) {
      context.commit('setShowModalCheckEmail', state);
    },
    toggleModalEnterCode(context, state = false) {
      context.commit('setShowModalEnterCode', state);
    },
    toggleModalLeaderboardData(context, state = false) {
      context.commit('setShowModalLeaderboardData', state);
    },
    toggleModalSlider(context, state = false) {
      context.commit('setShowModalSlider', state);
    },
    setGameTypes(context, payload) {
      context.commit('setGameTypes', payload);
    },
    clearAll(context) {
      context.commit('setUser', null);

      /* TODO: check */
      /* setTimeout(() => {
        context.commit('setError', null);
      }, 3000); */
    },
    setActiveGame(context, payload) {
      context.commit('setActiveGame', payload);
      localStorage.setItem('activeGame', payload);
    },
    setActiveGameType(context, payload) {
      context.commit('setActiveGameType', payload);
    },
    setActiveGamePlatform(context, payload) {
      context.commit('setActiveGamePlatform', payload);
    },
    setActiveTimeFilter(context, payload) {
      context.commit('setActiveTimeFilter', payload);
    },
  },
  getters: {
    modalBlur: state => {
      const {
        showModalBonus,
        showModalMenu,
        showModalSlider,
        showModalConfirm,
        showModalCheckEmail,
        showModalEnterCode,
        showModalLeaderboardData,
        error,
      } = state;
      const result = !!(
        showModalBonus ||
        showModalMenu ||
        showModalSlider ||
        showModalConfirm ||
        showModalCheckEmail ||
        showModalEnterCode ||
        showModalLeaderboardData ||
        error
      );

      return result;
    },
  },
});

export default store;
